<template>
    <div>
        <PageHeader title="รายงานผลการสอบ" />
        <b-container>
            <div class="py-2"></div>
            <div class="no-data" v-if="!hasExamData">
                ไม่พบข้อสอบ
            </div>
            <div class="py-3">
                <!-- search course -->
                <div class="inner bg-container">
                    <div style="display: flex">
                        <h6 style="margin-right: 150px; display: inline">
                            <strong class="pre-formatted">กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน </strong>
                        </h6>
                    </div>
                    <div class="mt-5">
                        <h6 class="mb-3"><strong>ชื่อคอร์ส</strong></h6>
                        <v-select
                            :options="courseData"
                            v-model="selectedCourse"
                            placeholder="พิมพ์ชื่อคอร์สที่ต้องการค้นหา..."
                            :disabled="!courseData.length"
                            :clearable="false"
                            :loading="isCourseDataLoading"
                        />
                    </div>

                    <!-- search exam -->
                    <div class="mt-5">
                        <h6 class="mb-3"><strong>เลือกข้อสอบ</strong></h6>
                        <v-select
                            :options="examOption"
                            v-model="selectedExam"
                            placeholder="พิมพ์ชื่อข้อสอบที่ต้องการค้นหา..."
                            :disabled="!examOption.length"
                            :clearable="false"
                            :loading="isExamDataLoading"
                        />
                    </div>

                    <div class="mt-5">
                        <h6 class="mb-3"><strong>วันที่ส่งข้อสอบ</strong></h6>
                        <div :class="['d-flex', { disabled: !isDateEditAble }]">
                            <div
                                class="date-picker left"
                                @click="
                                    datePicker = false;
                                    clearDate();
                                "
                                :class="{ active: datePicker === false }"
                            >
                                <h6 class="mb-0">วันทั้งหมด</h6>
                            </div>
                            <div
                                class="date-picker right"
                                @click="
                                    datePicker = true;
                                "
                                :class="{ active: datePicker === true }"
                            >
                                <h6 class="mb-0">ระบุวัน</h6>
                            </div>
                            <div v-if="datePicker" class="ml-3" style="position: relative;">
                                <b-input-group style="position: relative;">
                                    <b-form-input
                                        type="text"
                                        :value="formattedDate"
                                        placeholder="ระบุวันที่ต้องการค้นหา"
                                        disabled
                                    />
                                    <b-input-group-prepend>
                                        <b-button
                                            variant="primary"
                                            size="sm"
                                            @click="showCalendarRange()"
                                        >
                                            <b-icon
                                                icon="calendar3-range"
                                                style="color: #fff;"
                                            ></b-icon>
                                        </b-button>
                                    </b-input-group-prepend>
                                </b-input-group>
                                <DatePicker
                                    :id="'calendar-range'"
                                    locale="th"
                                    style="
                                            display: none;
                                            float: right;
                                            position: absolute;
                                            will-change: transform;
                                            left: 0px;
                                            z-index: 999;
                                        "
                                    v-model="range"
                                    is-range
                                />
                            </div>
                        </div>
                        
                    </div>

                    <!-- download report -->
                    <div class="mt-5">
                        <b-button
                            target="_blank"
                            id="export-report"
                            variant="primary"
                            style="display: inline-block;"
                            :disabled="!selectedExam || isLoading || ( datePicker && !this.range.end ) || showNoDataMessage"
                            @click="exportExcel()"
                        >
                            <span v-if="isLoading">
                                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                กำลังโหลด...
                            </span>
                            <span v-else>
                                <i class="fa fa-angle-double-down" aria-hidden="true"></i>
                                ดาวน์โหลดรายงาน
                            </span>
                        </b-button>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-alpine"
                        style="width: 1px; height: 1px; overflow: hidden; position: absolute; left: -9999px;"
                        :columnDefs="columnDefs"
                        :rowData="rowData"
                        @grid-ready="onGridReady"
                    />
                    <div class="no-data" style="margin-top: 50px;" v-if="showNoDataMessage">
                        ไม่พบข้อมูลรายงานผลการสอบ เนื่องจากไม่มีประวัติการสอบ
                    </div>
                </div>
                
            </div>
        </b-container>
    </div>
</template>

<script>
import PageHeader from "@/components/layouts/PageHeader.vue";
import api from "@/services/api.js";
import vSelect from "vue-select";
import axios from "@/services/exam-api.js";
import { AgGridVue } from "ag-grid-vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";

export default {
    name: "ExamAttendance",
    components: {
        PageHeader,
        vSelect,
        AgGridVue,
        DatePicker
    },
    data() {
        return {
            comId: this.$store.state.Company.companyInfo.id,
            courseData: [],
            hasCourseData: false,
            selectedCourse: null,
            courseId: null,
            isDisplayNoData: false,

            examData: [],
            examOption: [],
            hasExamData: true,
            selectedExam: null,

            memberEnroll: [],

            qlecId: null,
            examId: null,

            exportButton: true,
            isLoading: false,

            rowData: [],
            columnDefs: [],
            gridApi: null,
            gridColumnApi: null,

            range: {
                start: null,
                end: null,
            },

            datePicker: false,
            isDateEditAble: false,
            isDisable: false,
            showNoDataMessage: false,

            isCourseDataLoading: false,
            isExamDataLoading: false,
        }
    },
    async created() {
        try {
            this.isCourseDataLoading = true;
            const { data } = await api.get(`/v1/companies/${this.comId}/courses`);
            this.courseData = data.data.map(course => ({ label: course.courseName, value: course.courseId }));
            this.hasCourseData = !!this.courseData.length;
            this.isCourseDataLoading = false;
        } catch (error) {
            console.error('Error fetching course data:', error);
            this.$bvToast.toast('ไม่สามารถโหลดข้อมูลคอร์สได้ กรุณาลองใหม่อีกครั้ง', {
                variant: 'danger',
                autoHideDelay: 3000,
                noCloseButton: true,
                solid: true
            });
            this.courseData = [];
            this.hasCourseData = false;
            this.isCourseDataLoading = false;
        }
    },
    watch: {
        selectedCourse(newCourse) {
            this.examId = null;
            this.courseId = newCourse.value;
            this.fetchExamData();
            this.isDateEditAble = false;
            this.clearDate();
            this.datePicker = false;
            this.showNoDataMessage = false;
        },
        selectedExam(newExam) {
            if (!newExam) return;

            this.qlecId = newExam.value;

            const exam = this.examData.find(obj => obj.quiz_id === this.qlecId);

            this.examId = exam.quiz_examId;
            this.isDateEditAble = true;
            this.clearDate();
            this.datePicker = false;
            this.showNoDataMessage = false;
        },
        range: {
            handler() {
                this.showNoDataMessage = false;
            },
            deep: true
        },
    },
    methods: {
        async fetchExamData() {
            try {
                this.isExamDataLoading = true;
                const { data } = await api.get(`/v1/courses/${this.courseId}/exam`);
                this.examData = data;
                this.examOption = data.map(exam => ({ label: exam.lec_name, value: exam.quiz_id }));
                this.hasExamData = !!this.examOption.length;
                this.selectedExam = null;
                this.isExamDataLoading = false;
            } catch (error) {
                console.error('Error fetching exam data:', error);
                this.$bvToast.toast('ไม่สามารถโหลดข้อมูลข้อสอบได้ กรุณาลองใหม่อีกครั้ง', {
                    variant: 'danger',
                    autoHideDelay: 3000,
                    noCloseButton: true,
                    solid: true
                });
                this.examData = [];
                this.examOption = [];
                this.hasExamData = false;
                this.selectedExam = null;
                this.isExamDataLoading = false;
            }
        },
        generateColumnDefs(rowData) {
            if (!rowData || !rowData.length) return []

            // Find all keys across all rows to get the maximum questions and sections
            const allKeys = new Set()
            rowData.forEach(row => {
                Object.keys(row).forEach(key => allKeys.add(key))
            })
            const keys = Array.from(allKeys)

            // column ปกติ (fixed)
            const fixedColumns = [
                'cer_id',
                'm_id',
                'Username',
                'Group',
                'ชื่อ-สกุล',
                'วัน-เวลาที่ส่งข้อสอบ',
            ]

            const fixedDefs = fixedColumns
                .filter(k => keys.includes(k))
                .map(k => ({
                    headerName: k,
                    field: k,
                }))

            // คะแนนรวม Section X และ สถานะ Section X (interleaved)
            // Extract all section-related keys and sort them
            const sectionScoreKeys = keys
                .filter(k => k.startsWith('คะแนนรวม Section'))
                .sort((a, b) => {
                    const numA = parseInt(a.match(/\d+/)?.[0] || '0')
                    const numB = parseInt(b.match(/\d+/)?.[0] || '0')
                    return numA - numB
                })

            const sectionPercentKeys = keys
                .filter(k => k.startsWith('เปอร์เซ็นต์คะแนนรวม Section'))
                .sort((a, b) => {
                    const numA = parseInt(a.match(/\d+/)?.[0] || '0')
                    const numB = parseInt(b.match(/\d+/)?.[0] || '0')
                    return numA - numB
                })

            const sectionStatusKeys = keys
                .filter(k => k.startsWith('สถานะ Section'))
                .sort((a, b) => {
                    const numA = parseInt(a.match(/\d+/)?.[0] || '0')
                    const numB = parseInt(b.match(/\d+/)?.[0] || '0')
                    return numA - numB
                })

            // Interleave score and status columns
            const sectionDefs = []
            for (let i = 0; i < sectionScoreKeys.length; i++) {
                // Add score column
                sectionDefs.push({
                    headerName: sectionScoreKeys[i],
                    field: sectionScoreKeys[i],
                })
                if (sectionPercentKeys[i]) {
                    sectionDefs.push({
                        headerName: sectionPercentKeys[i],
                        field: sectionPercentKeys[i],
                    })
                }
                // Add status column if it exists
                if (sectionStatusKeys[i]) {
                    sectionDefs.push({
                        headerName: sectionStatusKeys[i],
                        field: sectionStatusKeys[i],
                    })
                }
            }

            // คะแนนรวมทั้งหมด และ สถานะรวม
            const totalDefs = []
            if (keys.includes('คะแนนรวมทั้งหมด')) {
                totalDefs.push({
                    headerName: 'คะแนนรวมทั้งหมด',
                    field: 'คะแนนรวมทั้งหมด',
                })
            }
            if (keys.includes('เปอร์เซ็นต์คะแนนรวมทั้งหมด')) {
                totalDefs.push({
                    headerName: 'เปอร์เซ็นต์คะแนนรวมทั้งหมด',
                    field: 'เปอร์เซ็นต์คะแนนรวมทั้งหมด',
                })
            }
            if (keys.includes('สถานะ')) {
                totalDefs.push({
                    headerName: 'สถานะ',
                    field: 'สถานะ',
                })
            }
            if (keys.includes('ระดับขั้นใบประกาศ')) {
                totalDefs.push({
                    headerName: 'ระดับขั้นใบประกาศ',
                    field: 'ระดับขั้นใบประกาศ',
                })
            }

            // q1, q2, q3 ... with grouped header - use max questions across all rows
            const questionKeys = keys
                .filter(k => /^q\d+$/.test(k))
                .sort((a, b) => {
                    return Number(a.replace('q', '')) - Number(b.replace('q', ''))
                })

            const questionDefs = questionKeys.map(k => ({
                headerName: k.replace('q', ''),
                field: k,
            }))

            // Create the final column structure
            const columnDefs = [
                ...fixedDefs,
                ...sectionDefs,
                ...totalDefs,
            ]

            // Add grouped header for questions if there are any
            if (questionDefs.length > 0) {
                columnDefs.push({
                    headerName: 'คะแนนรายข้อ',
                    children: questionDefs
                })
            }

            return columnDefs
        },
        async fetchData() {
            if (!this.examId) {
                throw new Error('กรุณาเลือกข้อสอบก่อนดาวน์โหลด')
            }

            try {
                let url = `${process.env.VUE_APP_EXAM_API_BASE_URL}/exams/${this.examId}/get-exam-skl-report`

                if (this.range.start && this.range.end) {
                    const startDate = moment(this.range.start).startOf('day').toISOString();
                    const endDate = moment(this.range.end).endOf('day').toISOString();

                    url += `?startDate=${startDate}&endDate=${endDate}`
                }

                const res = await axios.get(url);

                if (res.data.length === 0) {
                    this.rowData = []
                    this.columnDefs = []
                    this.showNoDataMessage = true
                    return
                }

                this.rowData = res.data
                this.columnDefs = this.generateColumnDefs(this.rowData)
                this.showNoDataMessage = false
            } catch (error) {
                console.error('Error fetching exam data:', error);
                this.$bvToast.toast('ไม่สามารถโหลดข้อมูลรายงานได้ กรุณาลองใหม่อีกครั้ง', {
                    variant: 'danger',
                    autoHideDelay: 3000,
                    noCloseButton: true,
                    solid: true
                });
                throw error
            }
        },
        onGridReady(params) {
            this.gridApi = params.api
            this.gridColumnApi = params.columnApi
        },
        async exportExcel() {
            if (!this.selectedExam) {
                alert('กรุณาเลือกข้อสอบก่อนดาวน์โหลด')
                return
            }

            this.isLoading = true

            try {
                // Fetch data first
                await this.fetchData()

                if (this.showNoDataMessage) {
                    return
                }

                // Wait for grid to update
                await this.$nextTick()

                // Check if grid is ready
                if (!this.gridApi) {
                    throw new Error('Grid is not ready')
                }

                // Export to Excel
                this.gridApi.exportDataAsExcel({
                    fileName: `exam-result-${moment().utcOffset('+07:00').format('YYYY-MM-DDTHH-mm-ss')}.xlsx`,
                    sheetName: 'Result',
                })
            } catch (error) {
                console.error('Error exporting:', error)
                this.$bvToast.toast('ไม่สามารถดาวน์โหลดรายงานได้ กรุณาลองใหม่อีกครั้ง', {
                    variant: 'danger',
                    autoHideDelay: 3000,
                    noCloseButton: true,
                    solid: true
                });
            } finally {
                this.isLoading = false
            }
        },
        showCalendarRange() {
            let rangeCalendar = document.getElementById("calendar-range");
            if (rangeCalendar.style.display == "inline-block") {
                rangeCalendar.style.display = "none";
            } else {
                rangeCalendar.style.display = "inline-block";
            }
        },
        clearDate() {
            this.range.start = null;
            this.range.end = null;
        }
    },
    computed: {
        formattedDate() {
            if (this.range.start) {
                let rangeCalendar = document.getElementById("calendar-range");
                if (rangeCalendar.style.display == "inline-block") {
                    this.showCalendarRange();
                }
                return (
                    moment(this.range.start).format("DD MMM YYYY") +
                    " - " +
                    moment(this.range.end).format("DD MMM YYYY")
                );
            } else {
                return "";
            }
        },
    },
}
</script>

<style lang="css" scoped>
.online-exam {
    color: orange;
    width: 100%;
    padding: 0.75rem 1.25rem;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 0.25rem;
}

.date-picker {
  padding: 6px 20px;
  color: #525252;
  border: 1px solid rgba(82, 82, 82, 0.2);
  height: calc(1.5em + 0.75rem + 2px);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date-picker.active {
  background: #007bff;
  color: #fff;
}

.date-picker.left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.date-picker.right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: 0px solid #707070;
}

.d-flex.disabled .date-picker {
  pointer-events: none;
  opacity: 0.6;
}
</style>